import React, { Component } from "react";
import Footer from "../footer/Footer";
import SideImgContent from "../util/side-img-content";
import StickyTab from "../util/sticky-tab";
import StickyTabContainer from "../util/sticky-tabs-container";
import TrustedBy from "../util/trusted-by";
// import { DojoMojoSweepstakes } from "./dojo-iframe-test";
import NetworkBanner from "./network-banner";
import WhatTheySay from "./what-they-say";

class Network extends Component {
  iframeRef = React.createRef();

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.iframeRef.current && window.location.search) {
      this.iframeRef.current.src =
        "https://www.dojomojo.com/landing/campaign/27a95754-65ca-401c-83fc-d2c7864df10b" +
        window.location.search;
    }
  };

  render() {
    return (
      <div>
        <NetworkBanner />
        <StickyTabContainer bannerHeight={680} start={950}>
          <StickyTab title={"Powerful Search"} icon={"ink-mag-glass"} href={"powerfulSearch"} />
          <StickyTab title={"Detailed Profiles"} icon={"detailed-info"} href={"detailedProfiles"} />
          <StickyTab title={"In-App Messaging"} icon={"chat-bubbles"} href={"inAppMessaging"} />
          <StickyTab title={"Analytics"} icon={"bar-chart"} href={"analytics"} />
        </StickyTabContainer>
        {/* <DojoMojoSweepstakes /> */}

        <TrustedBy background={"transparent"} />
        <SideImgContent
          title={"Powerful Search"}
          para={
            "Search by industry, list size and audience demographics. See what partners are searching for what kinds of partnerships."
          }
          imgSrc={"/images/login/side-imgs/network/newsfeed.png"}
          href={"powerfulSearch"}
        />
        <SideImgContent
          right={true}
          title={"Detailed Profiles"}
          para={
            "View list size, social following, audience geography and income information for any brand on DojoMojo."
          }
          imgSrc={"/images/login/side-imgs/network/campaign-profile.png"}
          href={"detailedProfiles"}
        />
        <SideImgContent
          title={"In-App Messaging"}
          para={
            "Quickly correspond with any brand in the DojoMojo network, straight from your DojoMojo inbox."
          }
          imgSrc={"/images/login/side-imgs/network/messaging.png"}
          href={"inAppMessaging"}
        />
        <SideImgContent
          right={true}
          title={"Partner Analytics"}
          para={"Understand which partners performed best with your audience, and when."}
          imgSrc={"/images/login/side-imgs/network/partner-analytics.png"}
          href={"analytics"}
        />
        <WhatTheySay />
        <Footer />
      </div>
    );
  }
}

export default Network;
